function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#5E5E5E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.628 0H3.372C1.515.014.012 1.817 0 4.046v21.908C.012 28.183 1.515 29.986 3.372 30h18.256c1.857-.014 3.36-1.817 3.372-4.046V4.046C24.988 1.817 23.485.014 21.628 0zm1.788 25.954c-.009 1.18-.804 2.135-1.788 2.145H3.372c-.984-.01-1.78-.965-1.788-2.145V4.046c.009-1.18.804-2.135 1.788-2.145h18.256c.984.01 1.78.965 1.788 2.145v21.908z",
  transform: "translate(-37 -498) translate(37 498)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 7H20V8H19zM5 7H17V8H5zM19 14H20V15H19zM5 14H17V15H5zM19 20H20V21H19zM5 20H17V21H5z",
  transform: "translate(-37 -498) translate(37 498)"
}))));

function SvgGroup12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12);
export default __webpack_public_path__ + "static/media/group-12.f3fb1a4d.svg";
export { ForwardRef as ReactComponent };